<app-bread-crumb></app-bread-crumb>
<div class="qa etf">
  <p-tabView [(activeIndex)]="activeIndex" (onChange)="selectChange($event)">

    <p-tabPanel [header]="'基金配息'">
      <main class="etf-list-trad">
        <app-fund-choice [inputFundSelectList]="fundSelectList" (searchEvent)="onSearch($event)"></app-fund-choice>
        <div class="fund-dividend">
          <table>
            <thead>
              <tr>
                <th>基金名稱</th>
                <th>配息頻率</th>
                <th>每單位<br>配息金額</th>
                <th>當期配息率(%)</th>
                <th>當期報酬率<br>(%，含息)</th>
                <th>基準日</th>
                <th>除息日</th>
                <th>發放日</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of fundYieldList">
                <tr>
                  <td class="block">
                    <div class="fund-name" (click)="goFundPage(item.CNo)" style="cursor: pointer;">{{item.CShortName}} <span class="warning-text" *ngIf="item.CWarning">
                        {{item.CWarning}}</span>
                    </div>
                  </td>
                  <td>{{item.CCgDividendTypeStr}}</td>
                  <td>{{item.CPerShare}}</td>
                  <td>{{item.CCurrentDYStr}}</td>
                  <td>{{item.CCurrentROIStr}}</td>
                  <td>{{item.CBaseDate | date: 'yyyy/MM/dd'}}</td>
                  <td>{{item.CExDate | date: 'yyyy/MM/dd'}}</td>
                  <td>{{item.CPayableDate | date: 'yyyy/MM/dd'}}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
          <p-panel class="p-panel" [collapsed]="baseService.Web$.value || (!baseService.Web$.value) ? false : true"
            [toggleable]="baseService.Web$.value ? false : true" *ngFor="let item of fundYieldList">
            <ng-template pTemplate="header">
              <div (click)="goFundPage(item.CNo)" style="cursor: pointer;">
                <a class="name">
                  <div>{{item.CShortName}}<span class="warning-text" *ngIf="item.CWarning"> {{item.CWarning}}</span>
                  </div>
                </a>
              </div>
            </ng-template>
            <ng-template pTemplate="headericons">
              <img class="black-arrow" src="/assets/images/black-arrow.svg" />
            </ng-template>
            <div class="panel-item">
              <div class="name">配息頻率</div>
              <div class="desc">{{item.CCgDividendTypeStr}}</div>
            </div>
            <div class="panel-item">
              <div class="name">每單位配息金額</div>
              <div class="desc">{{item.CPerShare}}</div>
            </div>
            <div class="panel-item">
              <div class="name">當期配息率(%)</div>
              <div class="desc">{{item.CCurrentDYStr}}</div>
            </div>
            <div class="panel-item">
              <div class="name">當期報酬率(%，含息)</div>
              <div class="desc">{{item.CCurrentROIStr}}</div>
            </div>
            <div class="panel-item">
              <div class="name">基準日</div>
              <div class="desc">{{item.CBaseDate}}</div>
            </div>
            <div class="panel-item">
              <div class="name">除息日</div>
              <div class="desc">{{item.CExDate }}</div>
            </div>
            <div class="panel-item">
              <div class="name">發放日</div>
              <div class="desc">{{item.CPayableDate}}</div>
            </div>
          </p-panel>
          <ng-container>
            <button *ngIf="TotalItems > (fundYieldList && fundYieldList.length)" class="arrow-btn" (click)="more()">
              顯示更多
              <div class="top-arrow"></div>
            </button>
            <p class="no-data" *ngIf="(fundYieldList && fundYieldList.length) >= TotalItems">無更多資料</p>
          </ng-container>
        </div>
      </main>
    </p-tabPanel>
    <p-tabPanel [header]="'配息組成'">
      <main class="etf-list-trad">
        <app-fund-choice [inputFundSelectList]="fundSelectList" (searchEvent)="onSearch($event)"></app-fund-choice>
        <div class="dividend-composition">
          <table>
            <thead>
              <tr>
                <th>基金名稱</th>
                <th>配息評價月份</th>
                <th>每單位配息金額</th>
                <th>可分配淨利益÷配息</th>
                <th>本金÷配息</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of FundComposition">
                <tr>
                  <td class="block">
                    <div class="fund-name" (click)="goFundPage(item.FundNo)" style="cursor: pointer;">{{item.FundShortName}} <span class="warning-text" *ngIf="item.FundWarning"> {{item.FundWarning}} </span>
                    </div>
                  </td>
                  <td>{{item.Year}}/{{item.Month}}</td>
                  <td>{{item.YieldStr}}</td>
                  <td>{{item.DistributeStr}}</td>
                  <td>{{item.PrincipalStr}}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
          <p-panel class="p-panel" [collapsed]="baseService.Web$.value || (!baseService.Web$.value) ? false : true"
            [toggleable]="baseService.Web$.value ? false : true" *ngFor="let item of FundComposition">
            <ng-template pTemplate="header">
              <div (click)="goFundPage(item.FundNo)" style="cursor: pointer;">
                <a class="name">
                  <div>{{item.FundShortName}}<span class="warning-text" *ngIf="item.FundWarning"> {{item.FundWarning}}</span>
                  </div>
                </a>
              </div>
            </ng-template>
            <ng-template pTemplate="headericons">
              <img class="black-arrow" src="/assets/images/black-arrow.svg" />
            </ng-template>
            <div class="panel-item">
              <div class="name">配息評價月份</div>
              <div class="desc">{{item.Year}}/{{item.Month}}</div>

            </div>
            <div class="panel-item">
              <div class="name">每單位配息金額</div>
              <div class="desc">{{item.YieldStr}}</div>

            </div>
            <div class="panel-item">
              <div class="name">可分配淨利益÷配息</div>
              <div class="desc">{{item.DistributeStr}}</div>
            </div>
            <div class="panel-item">
              <div class="name">本金÷配息</div>
              <div class="desc">{{item.PrincipalStr}}</div>
            </div>
          </p-panel>

          <ng-container>
            <button *ngIf="TotalItems > (FundComposition && FundComposition.length)" class="arrow-btn" (click)="more()">
              顯示更多
              <div class="top-arrow"></div>
            </button>
            <p class="no-data" *ngIf="(FundComposition && FundComposition.length) >= TotalItems">無更多資料</p>
          </ng-container>
        </div>
      </main>
    </p-tabPanel>
    <p-tabPanel [header]="'配息基準日'">
      <main class="etf-list-trad">
        <app-fund-choice [inputFundSelectList]="fundSelectList" (searchEvent)="onSearch($event)"></app-fund-choice>
      <div class="dividend-date">
        <table>
          <thead>
            <tr>
              <th>基金名稱</th>
              <th>收益分配評價日</th>
              <th>收益分配基準日</th>
              <th>除息日</th>
              <th>發放日</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of FundRecordDate">
              <tr>
                <td class="block">
                  <div class="fund-name" (click)="goFundPage(item.FundNo)" style="cursor: pointer;">{{item.FundShortName}} <span class="warning-text" *ngIf="item.FundWarning"> {{item.FundWarning}} </span>
                  </div>
                </td>
                <td>{{item.CDivDate}}</td>
                <td>{{item.RecordDate}}</td>
                <td>{{item.DividendDate}}</td>
                <td>{{item.PaymentDate}}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <p-panel class="p-panel" [collapsed]="baseService.Web$.value || (!baseService.Web$.value) ? false : true"
          [toggleable]="baseService.Web$.value ? false : true" *ngFor="let item of FundRecordDate">
          <ng-template pTemplate="header">
            <div>
              <!-- <a class="type">股票代碼 {{item.CStockNo}}</a> -->
              <a class="name">
                <div (click)="goFundPage(item.FundNo)" style="cursor: pointer;">{{item.FundShortName}}<span class="warning-text" *ngIf="item.FundWarning"> {{item.FundWarning}}</span>
                </div>
              </a>
            </div>
          </ng-template>
          <ng-template pTemplate="headericons">
            <img class="black-arrow" src="/assets/images/black-arrow.svg" />
          </ng-template>
          <div class="panel-item">
            <div class="name">收益分配評價日</div>
            <div class="desc">{{item.CDivDate}}</div>

          </div>
          <div class="panel-item">
            <div class="name">收益分配基準日</div>
            <div class="desc">{{item.RecordDate}}</div>

          </div>
          <div class="panel-item">
            <div class="name">除息日</div>
            <div class="desc">{{item.DividendDate}}</div>
          </div>
          <div class="panel-item">
            <div class="name">發放日</div>
            <div class="desc">{{item.PaymentDate}}</div>
          </div>
        </p-panel>

        <ng-container>
          <button *ngIf="TotalItems > (FundRecordDate && FundRecordDate.length)" class="arrow-btn" (click)="more()">
            顯示更多
            <div class="top-arrow"></div>
          </button>
          <p class="no-data" *ngIf="(FundRecordDate && FundRecordDate.length) >= TotalItems">無更多資料</p>
        </ng-container>
      </div>
      </main>
    </p-tabPanel>
    <p-tabPanel [header]="'淨值組成'">
      <main class="etf-list-trad">
        <app-fund-choice [inputFundSelectList]="fundSelectList" (searchEvent)="onSearch($event)"></app-fund-choice>
      <div class="nav-composition">
        <table>
          <thead>
            <tr>
              <th>基金名稱</th>
              <th>淨值日期</th>
              <th>(A)基本面額</th>
              <th>(B)收益平準金<br>(註1)</th>
              <th>(C)資本損益平準金<br>(註2)</th>
              <th>基金淨值(A+B+C)
                <div>(單位:元)</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of NavComposition">
              <tr>
                <td class="block">
                  <div class="fund-name" (click)="goFundPage(item.CFundNo)" style="cursor: pointer;">{{item.CFundShortName}} <span class="warning-text" *ngIf="item.CFundWarning"> {{item.CFundWarning}} </span>
                  </div>
                </td>
                <td>{{item.CNavDate}}</td>
                <td>{{item.CParval}}</td>
                <td>{{item.CAvgDiv}}</td>
                <td>{{item.CCapDiv}}</td>
                <td>{{item.CDivNav}}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <p-panel class="p-panel" [collapsed]="baseService.Web$.value || (!baseService.Web$.value) ? false : true"
          [toggleable]="baseService.Web$.value ? false : true" *ngFor="let item of NavComposition">
          <ng-template pTemplate="header">
            <div>
              <!-- <a class="type">股票代碼 {{item.CStockNo}}</a> -->
              <a class="name">
                <div (click)="goFundPage(item.CFundNo)" style="cursor: pointer;">{{item.CFundShortName}}<span class="warning-text" *ngIf="item.CFundWarning"> {{item.CFundWarning}}</span>
                </div>
              </a>
            </div>
          </ng-template>
          <ng-template pTemplate="headericons">
            <img class="black-arrow" src="/assets/images/black-arrow.svg" />
          </ng-template>
          <div class="panel-item">
            <div class="name">淨值日期</div>
            <div class="desc">{{item.CNavDate}}</div>

          </div>
          <div class="panel-item">
            <div class="name">(A)基本面額</div>
            <div class="desc">{{item.CParval}}</div>

          </div>
          <div class="panel-item">
            <div class="name">(B)收益平準金(註1)</div>
            <div class="desc">{{item.CAvgDiv}}</div>
          </div>
          <div class="panel-item">
            <div class="name">(C)資本損益平準金(註2)</div>
            <div class="desc">{{item.CCapDiv}}</div>
          </div>
          <div class="panel-item">
            <div class="name">基金淨值(A+B+C)<div class="note">(單位:元)</div></div>
            <div class="desc">{{item.CDivNav}}</div>
          </div>
        </p-panel>

        <ng-container>
          <button *ngIf="TotalItems > (NavComposition && NavComposition.length)" class="arrow-btn" (click)="more()">
            顯示更多
            <div class="top-arrow"></div>
          </button>
          <p class="no-data" *ngIf="(NavComposition && NavComposition.length) >= TotalItems">無更多資料</p>
        </ng-container>
      </div>
      </main>
    </p-tabPanel>
    <main>
      <ng-container >
        <div class="dividend-warning">
          <ol>
            <li>淨值組成項目主要由「基本面額」、「收益平準金」及「資本平準金」三部份所組成。</li>
            <li>「收益平準金」係指自基金成立日起，凡受益憑證申購或買回價金中，計算日時屬於原受益人每受益權單位淨資產價值中所累積之收入(包含但不限於利息收入)，扣除費用部分屬之。</li>
            <li>「資本平準金」金額包含「已實現及未實現」的資本損益及「已實現及未實現」的資本平準(申購及買回)。故係指自本基金成立日起，凡受益憑證申購或買回價金中，為計算日時屬於原受益人每受益憑證單位淨資產價值中之資本損益，依淨值比例計算其金額。</li>
            <div>【註1】係指本基金收入扣除應負擔費用(可能為負值)，包含因申購及買回產生之收益平準金，有關收益平準金之詳細說明請詳閱本基金信託契約或公開說明書。</div>
            <div>【註2】包含已實現及未實現的資本損益、已實現及未實現的資本損益平準金(申購及買回)。</div>
            <li>提醒投資人應將投資金融商品之海外所得併入個人基本所得額之海外所得申報及繳納所得稅，以避免因短漏報稅額遭稽徵機關補稅處罰。</li>
          </ol>
        </div>
      </ng-container>
    </main>
  </p-tabView>
</div>
